<template>
  <div class="discuss">
    <div class="item" v-for='(i,k) in showData' :key='k' @click="detail(i)">
      <div class="date">
        <img :src="i.url" alt="">
      </div>
      <div class="tbox">
        <div class="title">{{i.name}}</div>
        <!--<div class="sub">{{i.content}}</div>-->
      </div>
    </div>
    <div class="page">
      <i class="left iconfont icon-youjiantou" @click="prePage()"></i>
      <div class="item" :class="{active: current===k}" v-for='(i,k) in new Array(Math.ceil(total / size))' :key='k'>
        <div @click="currentPage(k)">{{k+1}}</div>
      </div>
      <i class="right iconfont icon-youjiantou" @click="nextPage()"></i>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      data: Array,
    },
    data() {
      return {
        showData: [],
        total: this.data.length,
        size: 5,
        current: 0
      }
    },
    created() {
      this.currentPage(0);
    },
    methods: {
      detail(data) {
        this.$emit('detail', data)
      },
      nextPage() {
        if (this.current + 1 == Math.ceil(this.total / this.size)) {
        } else {
          this.current = this.current + 1;
        }
      },
      // 上一页
      prePage() {
        if (this.current == 0) {
        } else {
          this.current = this.current - 1;
        }
      },
      // 点击页码
      currentPage(i) {
        this.current = i;
        this.watch
      }
    },
    watch: {
      data: function (newData, oldData) {
        console.log("activity", newData)  //newData就是orderData
        this.total = newData.length;
        this.showData = newData.slice(this.current * this.size, (this.current + 1) * this.size);
        //	methods的函数在这里调用可以获取到newOrderData的值
        //this.order();
      }
      ,
      current: function (newData, oldData) {
        console.log("activity", newData)  //newData就是orderData
        this.showData = this.data.slice(newData * this.size, (newData + 1) * this.size);
        //	methods的函数在这里调用可以获取到newOrderData的值
        //this.order();
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~styl/mixin.styl"
  .discuss
    mt(20)
    fs(0)
    min-height 350px

    .item
      mb(30)
      pb(20)
      border-bottom 1px solid rgba(0, 0, 0, .1)

      .date
        h(65)
        w(90)
        ib()
        va(middle)
        ln()
        width 7%

        img
          wh()

      .tbox
        width 93%
        box()
        pl(40)
        ln()
        ib()
        va(middle)

        .title
          c(#333)
          fs(22)

        .sub
          fs(14)
          c(gray)

  theme = #f7aa05

  .page
    ta(center)
    fs(0)

    .item
      ib()
      w(40)
      h(30)
      ml(10)
      mr(10)
      va(middle)
      fs(17)
      lh(30)
      c(gray)
      _hover()

      &.active
        bg(theme)
        c(#fff)

    .left
      fs(15)
      c(gray)
      ib()
      transform rotate(180deg)
      vertical-align -4px
      mr(10)

      &:hover
        cursor pointer

    .right
      &:hover
        cursor pointer
      ml(10)
      va(middle)
      c(gray)
      fs(15)
</style>



// WEBPACK FOOTER //
// src/components/comment/discuss.vue